<template>
    <div>
      <div class="product-evaluate">
        <div class="product-evaluate-item" v-for="item in goods_evaluation" :key="item.id">
          <h3>{{item.user_name}}</h3>
          <p>{{item.evaluation}}</p>
        </div>

      </div>
    </div>
</template>

<script>
    export default {
        name: "product-evaluate",
        props: {
          goods_evaluation:{
            type: Array,
            default: []
          }
        }
    }
</script>

<style scoped lang="scss">
  @import "../../assets/style/common";
  .product-evaluate{
    padding-top: 45px;
    .product-evaluate-item{
      margin-bottom: 33px;
      h3{
        @include font(18px,#333);
        margin-bottom: 33px;
      }
      p{
        @include font(18px,#666);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/system-com/product-evaluate.vue